// Application for Booking · View & Confirm (M3-F6; rows M3.44, M3.53; DC-167 / DC-181).
// The Application for Booking (latest version) → "I have read …" tick → OTP to the booking's contact
// person → "Confirmed on <date>". The Agreement KYC opens after this.
import React, { useEffect, useState } from "react";
import { Box, Modal } from "@mui/material";
import Close from "../../Icons/Close";
import { getAfb, sendAfbOtp, confirmAfb } from "../../../Services/Crm2Portal";
import { successTost } from "../../../Services/Toast";
import OtpEntry from "./OtpEntry";
import { niceDate } from "./Crm2Parts";
import css from "./Crm2Booking.module.css";
import useConsentPoint from "./TermsGate";

export default function AfbConfirmModal({ allotment, onClose, onDone }) {
	const apId = allotment.allotmentPaymentId;
	const [afb, setAfb] = useState(null);
	const [failed, setFailed] = useState(null);
	const [agree, setAgree] = useState(false);
	const [termsOk, setTermsOk] = useState(false);
	const { requirePoint, termsModal } = useConsentPoint();

	useEffect(() => {
		// M3-F11: Legal's terms on "afb_confirm" first, if any
		requirePoint("afb_confirm", apId, () => setTermsOk(true));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [apId]);

	useEffect(() => {
		getAfb(apId)
			.then(setAfb)
			.catch((err) => setFailed(err.message));
	}, [apId]);

	const confirmed = afb?.confirmedAt;
	if (termsModal) return termsModal;
	return (
		<Modal open onClose={(_, r) => r !== "backdropClick" && onClose()} sx={{ ".MuiBackdrop-root": { background: "rgba(52, 64, 84, 0.7)" } }} disableAutoFocus>
			<Box className={`${css.modal} ${css.modalWide}`}>
				<div className={css.modalHeader}>
					<span>Application for Booking{afb?.versionNo > 1 ? ` · version ${afb.versionNo}` : ""}</span>
					<span className={css.modalClose} onClick={onClose} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
				</div>
				<div className={css.modalContent}>
					{failed && <div className={css.badBox}>{failed}</div>}
					{!afb && !failed && <p className={css.muted}>Loading…</p>}
					{afb && (
						<>
							{afb.link?.url ? (
								<iframe className={css.docFrame} title="Application for Booking" src={afb.link.url} />
							) : (
								<p className={css.muted}>The document could not be shown. Please try again.</p>
							)}
							{afb.link?.url && (
								<a className={css.lk} href={afb.link.url} target="_blank" rel="noreferrer">
									Download PDF
								</a>
							)}
							{confirmed ? (
								<div className={css.good}>Confirmed on {niceDate(afb.confirmedAt)}{afb.confirmedVersionNo && afb.confirmedVersionNo !== afb.versionNo ? ` (version ${afb.confirmedVersionNo}); this is the latest version` : ""}.</div>
							) : (
								<>
									{afb.reconfirm && <div className={css.info}>Your unit was changed. Please read the new Application for Booking and confirm it again.</div>}
									<label className={css.tick}>
										<input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} />I have read my Application for Booking: unit, price, payment plan and cost sheet.
									</label>
									<OtpEntry
										disabled={!agree || !termsOk}
										sendLabel="I confirm · Send OTP"
										confirmLabel="Confirm Application for Booking"
										send={() => sendAfbOtp(apId)}
										verify={(challengeId, code) => confirmAfb(apId, challengeId, code)}
										onVerified={() => {
											successTost("Application for Booking confirmed. Your Agreement KYC is open now.");
											onDone();
										}}
									/>
								</>
							)}
						</>
					)}
				</div>
			</Box>
		</Modal>
	);
}
